/** Reglamento estadía sede vacacional Tocaima (Acuerdo 31/07/2024, REG-BS-01 v.008). */
export const vacacionesReglamento = {
  meta: {
    titulo: 'Reglamento de estadía — Sede vacacional Tocaima',
    codigo: 'REG-BS-01',
    version: '008',
    fechaActualizacion: '31 de julio de 2024',
    acuerdo: 'Acuerdo No. 31 / 07 / 2024',
    pdfUrl: '/documents/reglamento-sede-vacacional-tocaima.pdf',
    vigenciaDesde: '2024-07-31',
  },
  ubicacion: 'Tocaima, Cundinamarca',
  reserva: {
    formulario:
      'Formato de Solicitud de Servicio Estadía Inmueble Recreacional (disponible en coonaltragas.com o en oficinas).',
    aprobacion: 'Debe diligenciarse, enviarse a la cooperativa y ser aprobado según disponibilidad y cupo.',
    responsable:
      'Quien firma la solicitud es responsable ante la cooperativa por los bienes y espacios de la sede.',
  },
  horarios: {
    checkIn: '8:00 a.m.',
    checkOut: '3:00 p.m.',
    piscina: '9:00 a.m. — 7:00 p.m. (capacidad máxima 60 personas)',
    canchas: 'Hasta 10:00 p.m.',
    sonido: 'Música en áreas comunes hasta 2:00 a.m.',
  },
  tarifasHabitacion: {
    titulo: 'Sede vacacional Tocaima — valor por día y por habitación',
    nota: 'En días festivos se aplica la tarifa de fin de semana. Niños de 1 a 5 años: 50% de la tarifa; desde los 6 años: 100%.',
    filas: [
      {
        tipo: 'Asociados',
        lunJue: 49000,
        vieDom: 55000,
      },
      {
        tipo: 'No asociados',
        lunJue: 55000,
        vieDom: 62000,
      },
    ],
    pago: ['50% al momento de la reserva', '50% un día antes de la fecha de llegada'],
    capacidad: '6 habitaciones dotadas; capacidad máxima de hospedaje en la casa vacacional: 27 personas.',
  },
  tarifasCasas: {
    titulo: 'Casas Portales del Sol — Tocaima',
    nota: 'Valores de referencia vigentes 2026.',
    casas: [
      {
        nombre: 'Casa 1',
        asociados: { valor: 615000, cupo: 10 },
        noAsociados: { valor: 676500, cupo: 10 },
      },
      {
        nombre: 'Casa 2',
        asociados: { valor: 450000, cupo: 7 },
        noAsociados: { valor: 550000, cupo: 7 },
      },
    ],
    capacidadMax: 'Capacidad máxima de hospedaje: 8 personas (Casas Portales del Sol).',
  },
  pasadia: {
    titulo: 'Pasadía (piscina / duchas)',
    valor: 15000,
  },
  beneficios: [
    'Asociados: hasta 3 días consecutivos sin pago por cumpleaños (temporada baja, sujeto a disponibilidad).',
    'No asociados: el valor de la estadía debe cancelarse en su totalidad con 3 días de anticipación.',
  ],
  normasDestacadas: [
    'Habitaciones, baños, cocina y juegos se entregan inventariados y deben devolverse en buen estado.',
    'No trasladar bienes muebles a áreas húmedas (piscina). Ingreso vehicular solo por la entrada de la sede.',
    'Mascotas permitidas con restricciones: no sobre camas ni en piscina; el dueño responde por daños.',
    'Piscina: vestido de baño, ducha previa, gorro obligatorio; sin alimentos ni alcohol ni animales.',
    'Cancelación o cambio de fecha: avisar con 10 días de anticipación para evitar multa del 10% del valor reservado.',
  ],
  exoneraciones: [
    'La cooperativa no responde por accidentes, contagios ni pérdida u olvido de objetos personales.',
    'Incumplir indicaciones de seguridad exonera a la cooperativa si el usuario sufre daño o lesión.',
  ],
};
